import { store } from '@/store'

export default {
  types: {
    'HP': {
      title: 'Haftpflichtschutz',
      icon: 'agila:hps',
      submitClaim: true
    },
    'KS': {
      title: 'Tierkrankenschutz',
      icon: 'agila:tks',
      submitInvoice: true
    },
    'OP': {
      title: 'OP-Kostenschutz',
      icon: 'agila:ops',
      submitInvoice: true
    },
    'PH': {
      title: 'Privathaftpflicht',
      icon: 'agila:phv',
      submitClaim: true
    },
    'GP': {
      title: 'Tierkrankenschutz',
      icon: 'agila:tks',
      submitInvoice: true
    }
  },
  getTitle (type, offer) {
    return (this.types[type] ? this.types[type].title : '?') + ' ' + this.getGrade(offer)
  },
  getGrade (key) {
    if (key.includes('_EX')) {
      return 'Exklusiv'
    } else if (key.includes('_24')) {
      return '24'
    } else {
      return ''
    }
  },
  getIcon (type) {
    return this.types[type] ? this.types[type].icon : 'insuranceCase'
  },
  canSubmitInvoice (type) {
    return this.types[type] ? this.types[type].submitInvoice : false
  },
  canSubmitClaim (type) {
    return this.types[type] ? this.types[type].submitClaim : false
  },
  canCallEmergency (risk) {
    return store.state.settings.emergency_tariffs && store.state.settings.emergency_tariffs.split(',').map(number => parseInt(number.trim())).indexOf(risk.tariff_number) >= 0
  }
}